import { ENDPOINT } from "../config/endpoint.jsx";

export function cargarAllLocales() {
    return fetch(`${ENDPOINT}/locales`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(res => {
      if(!res.ok) throw new Error("Respuesta no Ok");
  
      return res.json();
    }).then(res => {
      const locales = res;
      return locales;
    })
  }

  